import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M24 44C12.954 44 4 35.047 4 24 4 12.954 12.953 4 24 4s20 8.953 20 20-8.953 20-20 20m0-2c9.943 0 18-8.058 18-18S33.942 6 24 6 6 14.058 6 24s8.058 18 18 18m-9.725-14.33a1 1 0 0 0 1.414.002l7.236-7.217a1.5 1.5 0 0 1 2.12.001l7.23 7.234a1 1 0 1 0 1.416-1.414l-7.23-7.233a3.5 3.5 0 0 0-4.948-.004l-7.236 7.216a1 1 0 0 0-.002 1.415",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Circled-Up-Outlined_svg__a",
      width: 40,
      height: 40,
      x: 4,
      y: 4,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 44C12.954 44 4 35.047 4 24 4 12.954 12.953 4 24 4s20 8.953 20 20-8.953 20-20 20m0-2c9.943 0 18-8.058 18-18S33.942 6 24 6 6 14.058 6 24s8.058 18 18 18m-9.725-14.33a1 1 0 0 0 1.414.002l7.236-7.217a1.5 1.5 0 0 1 2.12.001l7.23 7.234a1 1 0 1 0 1.416-1.414l-7.23-7.233a3.5 3.5 0 0 0-4.948-.004l-7.236 7.216a1 1 0 0 0-.002 1.415",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Circled-Up-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgCircledUpOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledUpOutlined_default = SvgCircledUpOutlined;

export { CircledUpOutlined_default as default };
